import { LANG_OPTIONS } from '@/common/constants/languages';
import storageManager from '@/api/storageManager';

export const SUPPORTED_LANGUAGES = [
	{ code: LANG_OPTIONS.polish, label: 'Polski', flagClass: 'flag-pl' },
	{ code: LANG_OPTIONS.german, label: 'Deutsch', flagClass: 'flag-de' },
	{ code: LANG_OPTIONS.english, label: 'English', flagClass: 'flag-en' },
	{ code: LANG_OPTIONS.czech, label: 'Čeština', flagClass: 'flag-cs' },
];

export const isLocalHost = () => {
	const host = window.location.hostname;
	return (
		host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')
	);
};

export const isSupportedLanguage = (code) =>
	Object.values(LANG_OPTIONS).includes(code);

export const readLanguageFromHost = () => {
	const subdomain = window.location.host.split('.')[0];
	if (isSupportedLanguage(subdomain)) {
		return subdomain;
	}
	return null;
};

export const readInitialLanguage = () => {
	const fromHost = readLanguageFromHost();
	if (fromHost) {
		return fromHost;
	}

	if (isLocalHost()) {
		return LANG_OPTIONS.english;
	}

	return null;
};

export const buildLanguageUrl = (lang) => {
	const { protocol, pathname, search, hash, host } = window.location;
	const parts = host.split('.');
	const hasLangPrefix = isSupportedLanguage(parts[0]);
	const baseHost = hasLangPrefix ? parts.slice(1).join('.') : host;

	return `${protocol}//${lang}.${baseHost}${pathname}${search}${hash}`;
};

export const applyLanguage = (lang, setLang, options = {}) => {
	const nextLang = isSupportedLanguage(lang) ? lang : LANG_OPTIONS.english;

	document.documentElement.lang = nextLang;

	if (isLocalHost()) {
		setLang?.(nextLang);
		return;
	}

	let nextUrl = buildLanguageUrl(nextLang);

	if (options.transferAuth && options.token) {
		nextUrl = storageManager.auth.appendTransferToUrl(nextUrl, {
			token: options.token,
			refreshToken: options.refreshToken,
		});
	}

	window.location.assign(nextUrl);
};
